/**
 * OnboardingPage saga functions
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import { handleError } from '../../Lib/Utils/saga-utils';
import { actions } from './slice';
import UserAPI from '../../Lib/Api/user';

export function* getUser({ payload: { userId } }) {
  try {
    const response = yield call(UserAPI.getOne, userId);
    const { user } = response;
    yield put(actions.getUserSuccess({ user }));
  } catch (err) {
    yield handleError(actions.getUserError, err);
  }
}

function* usersSaga() {
  yield takeLatest(actions.getUser.type, getUser);
}

export default usersSaga;
